import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChartModule } from 'angular2-highcharts';
import { HighchartsStatic } from 'angular2-highcharts/dist/HighchartsService';

import { ChartsComponent } from './charts.component';
import { HighStockChartComponent } from './high-stock-chart/high-stock-chart.component';
import { HighStockService } from './high-stock-chart/high-stock.service';

export function highchartsFactory() {
    return require('highcharts/highstock');
}

@NgModule({
  imports: [
      CommonModule,
      ChartModule
      //ChartModule.forRoot(require('highcharts/highstock'))
  ],
  declarations: [ChartsComponent, HighStockChartComponent],
  exports: [ChartsComponent],
  providers: [
      HighStockService,
      {
          provide: HighchartsStatic,
          useFactory: highchartsFactory
      }
  ]
})

export class ChartsModule { }



// WEBPACK FOOTER //
// ./src/app/charts/charts.module.ts